import { useQuery } from 'react-query';
import { PeopleProfile } from '@oh-vcp/components-common';
import { AxiosError } from 'axios';
import { fetchProfile } from './profileService';

const fetchPeopleProfileById = async (id: string): Promise<PeopleProfile> => {
  return fetchProfile<PeopleProfile>('profiles/people', id);
};

// todo: Here we can make a switch between public/private if the URIs are different!
const usePeopleProfileQuery = (id: string | undefined) => {
  return useQuery<PeopleProfile, AxiosError>(
    ['peopleProfile', id],
    () => fetchPeopleProfileById(id!),
    {
      enabled: !!id,
      refetchOnWindowFocus: false
    }
  );
};

export default usePeopleProfileQuery;
